function getCell(cell, _ref) {
  var rowData = _ref.rowData,
      rowIndex = _ref.rowIndex,
      columnIndex = _ref.columnIndex,
      _dragHandleProps = _ref._dragHandleProps;

  if (typeof cell === 'string') {
    return rowData[cell];
  } else if (cell) {
    return cell(rowData, {
      rowIndex: rowIndex,
      columnIndex: columnIndex,
      _dragHandleProps: _dragHandleProps
    });
  }
}

export default getCell;